import { TAgent } from '../../types/agent';
import { getPhoneString } from '../../utils/phone';

export function isCallbackAvailable(agent: TAgent | null): boolean {
  return Boolean(agent && getPhoneString(agent.phone));
}
